var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"6.7","cy":"6.7","r":"5.8","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11","y1":"11.1","x2":"15.1","y2":"15.2","key":1})]));
}

Search.displayName = "Search";

Search.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Search;

Search.default = Search;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/search.svg
// module id = ../icon/src/icons/search.svg
// module chunks = 0